import FacebookLogo from 'Shared/icons/logos/facebook.svg';
import { useTranslations } from '@ifixit/i18n/hooks';
import FacebookLogin from '@greatsumini/react-facebook-login';
import { Auth } from 'Shared/auth';

export function FacebookSSOButton({
   loginHandler,
   setError,
   text,
}: {
   loginHandler: (response: any) => void;
   setError: (error: string) => void;
   text: string;
}) {
   const t = useTranslations('Login');
   if (!App.facebookLoginEnabled) {
      return null;
   }

   return (
      <FacebookLogin
         appId={App.facebookAppId}
         initParams={{
            version: 'v18.0',
            cookie: true,
         }}
         onSuccess={() => {
            (Auth as any).clearCookies();
            (Auth as any).sendFacebookLogin(loginHandler);
         }}
         onFail={(_error: any) => {
            setError(t('unableToCompleteFacebookLogin'));
         }}
         render={(renderProps: any) => (
            <button
               id="facebookLogin"
               className="button-outline button-lg w-full gap-2"
               onClick={renderProps.onClick}
               data-mobile-appid="facebookLogin"
            >
               <FacebookLogo className="size-6.5" />
               {text}
            </button>
         )}
      />
   );
}
